import { useMutation } from "@tanstack/react-query";
import { updateSet, type WorkoutSetType } from "api-client";

import { useAuthenticatedNavigationContext } from "src/layout/AuthenticatedNavigationContext";

import { useWorkoutEditStore } from "./WorkoutEditContext";

interface UpdateSetTypeInput {
  setId: string;
  type: WorkoutSetType | null;
}

export function useUpdateSetType() {
  const workoutEditStore = useWorkoutEditStore();
  const { startSaving } = useAuthenticatedNavigationContext();

  const mutation = useMutation({
    mutationFn: (arg: UpdateSetTypeInput) => {
      return updateSet({
        path: { workoutId: workoutEditStore.workout.id, setId: arg.setId },
        body: { type: arg.type },
      });
    },
    onMutate: (arg) => {
      workoutEditStore.updateWorkoutSet(arg.setId, { type: arg.type });
    },
  });

  function perform(setId: string, type: WorkoutSetType | null) {
    const stop = startSaving();

    mutation.mutate(
      { setId, type },
      {
        onSuccess: () => {
          stop();
        },
        onError: () => {
          stop("error");
        },
      },
    );
  }

  return {
    mutation,
    perform,
  };
}
